import controller from '../../../../Scripts/Controller.js';
// import Masonry from 'masonry-layout';
// import FontFaceObserver from 'fontfaceobserver';

function StartPageTeasers(container) {
    // Temporarily disable Masonry and Fontface
    /*
    function init() {
      var elem = document.querySelector('.teasers');
      var msnry = new Masonry( elem, {
        itemSelector: '.teaser',
        gutter:20,
        transitionDuration:0
      });

      var font = new FontFaceObserver('ITC Century W01');
      font.load().then(function () {
        msnry.layout();
      });
    }
    return {
        init: init
    }
    */
}

controller.add('StartPageTeasers', StartPageTeasers);

export default StartPageTeasers;
